module.exports = __webpack_public_path__ + "static/media/icomoon.9fade565.ttf";